<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-30 15:46:20
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-01-19 18:05:57
 * @FilePath: \sns-user-frontend\src\components\card\commentCard.vue
 * @Description: 
-->
<template>
  <div 
    v-if="cardInfo.status !== 'delete'"
    :class="`comment-card ${isXsCard ? 'reply-card' : ''}`" 
    ref="cardRef"
  >
    <!-- 头像 -->
    <Avatar
      v-if="avatarInfo.avatar"
      :avatarInfo="avatarInfo"
      :size="isXsCard ? 32 : 40"
    >
    </Avatar>
    <div class="comment-card-main">
      <div class="avatar-info"
        :style="{
          height: `${isXsCard ? 32 : 40}px`}"
      >
        <!-- 昵称 -->
        <div class="avatar-info-lt">
          <span>{{avatarInfo.nickname}}</span>
          <MedalIcon v-if="avatarInfo.medalIcon" :medalLink="avatarInfo.medalIcon"/>
        </div>
        <div class="avatar-info-rt">
          <!-- 是否置顶 -->
          <svg-icon v-if="cardInfo.stick || cardInfo.verified" name="icon-stick"/>
          <!-- 点赞 -->
          <Like 
            v-if="(uid !== avatarInfo.id)"
            type="comment"
            :uid="avatarInfo.id"
            :id="cardInfo.id"
            :tid="cardInfo.tid"
            :status="cardInfo.praised"
            @update:status="updateStatus"
          />
          <!-- 更多操作 -->
          <el-dropdown popper-class="comment-card" placement="bottom-end" v-if="actionPop" >
            <svg-icon name="icon-more" @mouseenter="enterMoreAction" />
            <template #dropdown>
              <dl 
                class="comment-card-action"
              >
                <dt
                  :class="item.hasline ? 'hasline' : ''"
                  v-for="item in moreOptions"
                  :key="`${item.name}${item.value}`"
                  @click="onSelectSort(item)"
                >{{$t(item.name)}}</dt>
              </dl>
            </template>
          </el-dropdown>
        </div>
      </div>
      <!-- 帖子引用 -->
      <div class="comment-card-quote" v-if="cardInfo.quote" @click="showQuote">
        <!-- 引用文本 -->
        <div class="quote" v-html="cardInfo.quote"></div>
        <!-- 帖子作者 -->
        <Avatar 
          :avatarInfo="authorInfo"
          :size="24"
          :iconSize="9"
        >
          <span>{{authorInfo.nickname}}</span>
        </Avatar>
      </div>
      <!-- 评论/回复正文 -->
      <div :class="`${isXsCard ? 'reply' : 'comment'}-content content` " v-html="cardInfo.content" ref="commentRef"></div>
      <div class="comment-card-info">
        <!-- 发表时间 -->
        <span>{{$timeFormat(cardInfo.ctime)}}</span>
        <!-- 机型 -->
        <span v-if="cardInfo.model">{{cardInfo.model}}</span>
        <!-- 点赞数 -->
        <span>{{cardInfo.commentStat.praiseCount}} {{$t('like', cardInfo.commentStat.praiseCount)}}</span>
        <!-- 合并帖子标记 -->
        <MergerTooltip v-if="cardInfo.merged == 1" />
        <!-- 标记数 -->
        <span v-if="getPermission.commentMark && commentMarkCount" @click="openCommentMark" class="secondary">{{ commentMarkCount }} {{ $t('commentMark', commentMarkCount) }}</span>
        <!-- 回复按钮 -->
        <span class="secondary" @click="toCommentDetail">{{ $t('reply') }}</span>
      </div>
      <!-- 精选 -->
      <FeatureTooltip v-if="cardInfo.featured" /> 
      <!-- 用于加载回复的插槽 -->
      <slot></slot>
    </div>
    <ObPopup v-model="quoteVisible" height="calc(100vh - var(--orbit-nav-height, 0px))" teleport="">
      <div class="quote-detail">
        <p>{{$t('quote')}}</p>
        <div v-html="quoteContent" ref="quoteRef"></div>
        <Avatar 
          :avatarInfo="authorInfo"
          :size="32"
          :iconSize="11"
        >
          <span>{{authorInfo.nickname}}</span>
        </Avatar>
      </div>
    </ObPopup>
  </div>
  <Report v-model="reportVisible" :type="cardInfo.parentCid ? '4' : '3'" :reportId="cardInfo.id"/>
  <Dialog v-model:visible="commentMarkVisible" :showFoot="false" :title="`${markUserTotal} ${$t('commentMark')}`">
    <div class="user-container">
      <svg-icon name="icon-close" class="close" @click="commentMarkVisible = false"></svg-icon>
      <van-list
        v-model:loading="loading"
        :finished="finished"
        :loading-text="$t('loading')"
        finished-text=" "
        :immediate-check="false"
        @load="getMarkUser" :error="error" error-text="network error">
        <ul class="user-list">
          <li v-for="item in markUserList" :key="item.uid">
            <Avatar
              :avatarInfo="{
                id: item.uid,
                icon: item?.userIconVO,
                avatar: item.avatar
              }"
              :size="48"
              :iconSize="13"
            >
              <span class="name">{{ item.nickname }}</span>
            </Avatar>
          </li>
        </ul>
      </van-list>
    </div>
  </Dialog>
  <!-- 新增标签弹窗 -->
  <addLabel :media="media" :threadInfo="cardInfo" v-model="addLabelVisible"></addLabel>
  <!-- 新增媒体资源标签 -->
  <addLabel :media="media" :threadInfo="cardInfo" v-model="addMediaVisible"></addLabel>
  <!-- 选择理由弹窗 -->
  <Report v-model="reasonVisible" :type="cardInfo.parentCid ? '4' : '3'" :reportId="cardInfo.id" :reasonOnly="true" @afterSelect="afterSelectDel"/>
  <WebImgPreview 
    v-model:visible="showPreview"
    :previewList="imgPreviewList"
    :previewIndex="previewIndex"
  />
</template>

<script setup>
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia';

import MergerTooltip from '@/components/card/mergerTooltip'
import Avatar from '@/components/avatar'
import Like from '@/components/like'
import Drawer from '../web/drawer'
import { getCurrentInstance, onMounted, reactive, ref, watch, computed, nextTick, toRefs, toRef, toRaw } from 'vue';
import http from '@/service'

import { richText4View, recoverQuoteImg } from '@/utils/formatRichText'
import { copyText } from '@/utils'

import { useRoute } from 'vue-router';

const route = useRoute()
const { proxy } = getCurrentInstance()

const userStore = useUserStore()
const { uid, getPermission } = storeToRefs(userStore)

const emit = defineEmits(['edit', 'reply', 'updateCount', 'updateList','updateSecondList'])

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => {}
  },
  authorInfo: {
    type: Object,
    default: () => {}
  },
  cardType: {
    type: String,
    default: 'normal'
  },
  threadInfo: {
    type: Object,
    default: () => {}
  },
  actionPop: {
    type: Boolean,
    default: true
  }
})

// 卡片引用
const cardRef = ref(null)


const commentRef = ref(null)
const quoteRef = ref(null)
const imgPreviewList = ref([])
const reportVisible = ref(false)
const commentMarkVisible = ref(false)
const addLabelVisible = ref(false)
const addMediaVisible = ref(false)
const reasonVisible = ref(false)
const media = ref([])
const deleteReason = ref('')


const cardInfo = ref({})  // 卡片数据
const avatarInfo = ref({})  // 用户数据
const quoteVisible = ref(false)
const quoteContent = ref('')

// 卡片操作项
const actionList = ref([])
const moreOptions = computed({
  get: () => {
    // 卡片数据
    const { 
      fromUserBasicInfo = {}, 
      status, 
      stick, 
      type,
      marked,
      verified,
      featured,
      commentStat = {}
    } = cardInfo.value
    // 是否作者
    const isAuthor = uid.value === fromUserBasicInfo.uid
    // 权限列表
    const { commentStick, threadEdit, threadDelete, commentMark, label , hideComment, commentVerified, commentFeatured} = getPermission.value
    // 是否圈主/副圈主
    const isCircleEditor = props.threadInfo?.loginIdentityType === 1 || props.threadInfo?.loginIdentityType === 2
    // 是否完成审核
    const auditComplete = status === 1 || status === 3
    
    // 获取data-type 区分图片和表情
    const regex = /<img[^>]*data-type=['"]([^'"]*)['"][^>]*>/g;
    let match;
    const dataTypeValues = [];
    while ((match = regex.exec(cardInfo.value?.content)) !== null) {
      dataTypeValues.push(match[1]);
    }

    actionList.value = [{
      name: 'copyLink',
      show: true
    }, {
      name: 'edit', // 编辑
      show: auditComplete && (isAuthor || threadEdit)
    },{
      name: 'hideComment', // 隐藏评论
      show: hideComment
    }, {
      name: 'report', // 举报
      show: uid.value && (uid.value !== fromUserBasicInfo.uid)
    }, {
      name: 'delete', // 删评论/回复
      show: isAuthor || threadDelete || isCircleEditor,
      hasline: true
    }, {
      name: 'addLabel',
      show: label,
      // hasline: true
    }, {
      name: 'mediaLabel',
      show: label && dataTypeValues.includes('file') && !cardInfo.value.attachments[0]?.oliveInfo,
    }, {
      name: stick ? 'cancelStick' : 'stick',  // 置顶
      show: (type === '0' && commentStick),
      // hasline: !commentMark
    }, {
      name: verified ? 'cancleVerified' : 'verified', // 官方回复
      show: commentVerified && type === '0',
    }, {
      name: featured ? 'cancleFeatured' : 'featured', // 精选
      show: commentFeatured,
    }, {
      name: marked ? 'commentUnMark' : 'commentMark', // 评论标记
      show: (type === '0' && commentMark),
      // hasline: true
    }]
    return actionList.value.filter(i => i.show)
  },
  set: (type) => {
    if (type === 'stick') {
      actionList.value.find(i => i.name === type).name = 'cancelStick'
    }
    if (type === 'cancelStick') {
      actionList.value.find(i => i.name === type).name = 'stick'
    }
    if (type === 'commentMark') {
      actionList.value.find(i => i.name === type).name = 'commentUnMark'
    }
    if (type === 'commentUnMark') {
      actionList.value.find(i => i.name === type).name = 'commentMark'
    }
    if (type === 'verified') {
      actionList.value.find(i => i.name === type).name = 'cancleVerified'
    }
    if (type === 'cancleVerified') {
      actionList.value.find(i => i.name === type).name = 'verified'
    }
    if (type === 'featured') {
      actionList.value.find(i => i.name === type).name = 'cancleFeatured'
    }
    if (type === 'cancleFeatured') {
      actionList.value.find(i => i.name === type).name = 'featured'
    }
  }
})
// 分享链接，评论/回复
const shareLink = computed(() => {
  const tid = cardInfo.value.tid
  const type = cardInfo.value.type
  const cid = type === '0' ? cardInfo.value.id : cardInfo.value.parentCid
  const rid = type === '1' ? cardInfo.value.id : ''
  const link = `${location.origin}/thread/${tid}?parentCid=${cid}${rid ? `&replyCid=${rid}` : ''}`
  return link
})

// 是否正常卡片大小
const isXsCard = computed(() => {
  const isSmallerCard = props.cardType === 'normal' && cardInfo.value.type === '1'
  return isSmallerCard
})


const io = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    const { intersectionRatio, target } = entry
    // 图片懒加载
    if (entry.isIntersecting && target.dataset.src) {
      target.src = target.dataset.src
      target.dataset.src && target.attributes.removeNamedItem('data-src')
      io.unobserve(target)
    }
  })
}, {
  root: null, // 边界值参照节点，必须为监听元素的祖先元素
  rootMargin: '0px', // 边界触发临界值，左右上下
  threshold: [0.2, 0.5, 1], // 触发回调的节点，0表示元素刚完全不可见，1表示元素刚完全可见，0.5表示元素可见了一半等
});

// 图片懒加载
const showPreview = ref(false)
const previewIndex = ref(0)
const imgLazyLoad = (dom) => {
  imgPreviewList.value = []
  Array.from(dom.querySelectorAll('img[data-src]')).forEach((img, index) => {
    io.observe(img)
    // 判断是不是动图
    const dataValue =  img.getAttribute('data-value')
    const targetPreviewItem = cardInfo.value.attachments.find((item) => item.id === dataValue)
    let imgItem = img.dataset.src || img.src
    if (targetPreviewItem && targetPreviewItem.oliveInfo){
      imgItem = {
        type: 5,
        url:img.dataset.src || img.src,
        ...targetPreviewItem?.oliveInfo
      }
    }
    imgPreviewList.value.push(imgItem)
    img.addEventListener('click', () => {
      previewIndex.value = index
      showPreview.value = true
    })
  })
}


const sendGaData = (name, data) => {
  let params = {
    "screen_name": route.name,
    "thread_category": props.threadInfo?.type,
    "thread_id": route.params.id,
    "circle_id": props.threadInfo?.circleBasicInfo?.id,
    "circle_name": props.threadInfo?.circleBasicInfo?.name,
    "post_id": props.modelValue?.parentCid || props.modelValue?.id
  }
  proxy.$ga(name, {...params,...data})
}

const enterMoreAction = () => {
  sendGaData('post_more_action', {button_name: 'Comment more actions'})
}

// 更多操作
const onSelectSort = ({ name }) => {
  switch (name) {
    case 'stick':
    case 'cancelStick':
      sendGaData(name === 'stick' ? 'post_stick' : 'post_unstick')
      onHandelStick(name)
      break
    case 'copyLink':
      sendGaData('post_copy', {
        "button_name": 'Copy link'
      })
      copyText(shareLink.value).then(res => {
        proxy.$toast({
          message:  proxy.$t('copyToast'),
          duration: 2000,
        })
      })
      break
    case 'edit':
      sendGaData('post_edit')
      cardInfo.value.quoteText = props.modelValue.quote
      emit('edit', cardInfo.value)
      break
    case 'hideComment':
      toHideComment()
      break
    case 'report':
        sendGaData('post_report')
        reportVisible.value = true
      break
    case 'commentMark':
      changeCommentMark('commentMark')
      break
    case 'commentUnMark':
      changeCommentMark('commentUnMark')
      break
    case 'addLabel':
      media.value = []
      addLabelVisible.value = true
      break
    case 'mediaLabel':
      const regex = /<img[^>]*data-type=['"]([^'"]*)['"][^>]*>/g;
      let match;
      let contentImgId;
      while ((match = regex.exec(cardInfo.value.content)) !== null) {
        if(match[1].includes('file')){
          const tag = document.createElement('div')
          tag.innerHTML = match[0]
          const dataValue = tag.childNodes[0].getAttribute('data-value')
          contentImgId = dataValue
        }
      }
      let targetMedia = cardInfo.value.attachments.filter((item) => item.id === contentImgId)
      media.value = targetMedia
      addMediaVisible.value = true
      break
    case 'delete':
      if (uid.value !== props.modelValue?.fromUserBasicInfo?.uid) {
        reasonVisible.value = true
        return
      }
      sendGaData('post_delete')
      onDelteComment()
      break
    case 'verified':
    case 'cancleVerified':
      changeVerify(name)
      break
    case 'featured':
    case 'cancleFeatured':
      changeFeature(name)
      break
    default:
  }
}

let pages = ref({
  page: 1,
  limit: 15
})
let loading = ref(false)
let finished = ref(false)
let error = ref(false)

let markUserList = ref([])
let markUserTotal = ref(0)

const openCommentMark = () => {
  pages.value.page = 1
  markUserList.value = []
  getMarkUser()
}

// 查看标记的用户
const getMarkUser = async () => {
  const { code, data, msg} = await http.getMarkUser({
    id: cardInfo.value.id,
    ...pages.value
  })
  if (code === 200 && data) {
    finished.value = pages.value.page * pages.value.limit >= data.total
    pages.value.page ++
    markUserList.value = [
        ...markUserList.value,
        ...data.rows
    ]
    loading.value = false
    markUserTotal.value = data.total
    commentMarkVisible.value = true
  } else {
    markUserList.value = []
    finished.value = true
    loading.value = false
    proxy.$toast({
      message: msg
    })
  }
}

// 隐藏评论
const toHideComment = async()=>{
  const { code, data, msg} = await http.hideComment({
    id: cardInfo.value.id,
    tid: cardInfo.value.tid
  })
  proxy.$toast({
    message: msg
  })
  if (code === 200) {
    if(uid.value === cardInfo.value?.fromUserBasicInfo.uid){
      // 自己隐藏自己 还是显示
      return
    }
    cardInfo.value.status = 'delete'
    emit('updateCount')
  }
}

// 评论标记 标记/取消标记
const changeCommentMark = async (type) => {
  const requestType = type == 'commentMark' ? 'markComment' : 'unMarkComment'
  const { code, data, msg} = await http[requestType]({
    id: cardInfo.value.id
  })
  if (code === 200 && data) {
    // 标记/取消标记成功 更新标记数量
    moreOptions.value = type
    cardInfo.value.marked = type === 'commentMark'
    type === 'commentMark' ? commentMarkCount.value += 1 : commentMarkCount.value -= 1
  }
  proxy.$toast({
    message: msg
  })
}

// 评论 置顶/取消置顶
const onHandelStick = async (type) => {
  const { code, data, msg } = await http[`comment${type}`]({
    id: cardInfo.value.id,
    tid: cardInfo.value.tid
  })
  if (code === 200 && data) {
    moreOptions.value = type
    cardInfo.value.stick = type === 'stick'
    emit('updateList')
  }
  proxy.$toast({
    message: msg
  })
}

// 官方回复/取消官方回复
const changeVerify = async (type) => {
  const requestType = type == 'verified' ? 'addVerified' : 'cancelVerified'
  const { code, data, msg} = await http[requestType]({
    id: cardInfo.value.id,
    tid: cardInfo.value.tid
  })
  if (code === 200) {
    cardInfo.value.verified = type === 'verified'
    props.threadInfo.verified = type === 'verified'
    emit('updateList')
  }
  proxy.$toast({
    message: msg
  })
}

// 精选/取消精选
const changeFeature = async (type) => {
  const requestType = type == 'featured' ? 'addFeatured' : 'cancelFeatured'
  const { code, data, msg} = await http[requestType]({
    id: cardInfo.value.id,
    tid: cardInfo.value.tid,
    parentCid: cardInfo.value.parentCid,
    commentType:cardInfo.value.type,
  })
  if (code === 200 && data) {
    cardInfo.value.featured = type === 'featured'
    cardInfo.value.type == 1 ? 
    setTimeout(() => {
      emit('updateSecondList')
    }, 1000) : emit('updateList')
  }
  proxy.$toast({
    message: msg
  })
}

// 删除评论
const onDelteComment = async () => {
  const { code, data, msg } = await http.deleteComment({
    id: cardInfo.value.id,
    tid: cardInfo.value.tid,
    reason: deleteReason.value
  })
  if (code === 200 && data) {
    cardInfo.value.status = 'delete'
    // 手动削减评论总数
    emit('updateCount', 'delete')
    proxy.$toast({
      message: proxy.$t('deleted')
    })
    return
  }
  proxy.$toast({
    message: msg
  })
}

// 打开评论详情页
const toCommentDetail = () => {
  const { parentCid, id } = cardInfo.value
  emit('reply', cardInfo.value)
}

// 更新点赞状态
const updateStatus = (status) => {
  cardInfo.value.praised = status
  if (status) {
    cardInfo.value.commentStat.praiseCount += 1
  } else {
    cardInfo.value.commentStat.praiseCount -= 1
  }
}

// 显示引用
const showQuote = () => {
  quoteVisible.value = true
}

const afterSelectDel = (val) => {
  deleteReason.value = val.name
  onDelteComment()
  reasonVisible.value = false
}

const commentMarkCount = ref(0)


watch(() => props.modelValue, (val) => {
  if (!val || !Object.keys(val)) return
  nextTick(() => {
    imgLazyLoad(commentRef.value)
  })
  const { uid: id, avatar, iconLink: icon, nickname, medalIcon, dressInfo } = val.fromUserBasicInfo
  nextTick(() => {
    avatarInfo.value = { id, avatar, icon, nickname, medalIcon, ...dressInfo }
  })
  cardInfo.value = JSON.parse(JSON.stringify(val))
  commentMarkCount.value = cardInfo.value?.commentStat?.markCount
  // 富文本格式化

  cardInfo.value.content = richText4View(cardInfo.value, {
    imgMaxWidth: 195,
    viewType: 'commentListImg'
  })
  if (cardInfo.value.quote) {
    console.log(cardInfo.value)
    cardInfo.value.quote = richText4View({
    ...cardInfo.value,
      content: cardInfo.value.quote
    }, {
      viewType: 'quote',
    })
    quoteContent.value = recoverQuoteImg(cardInfo.value.quote, cardInfo.value.attachments)
  }
  // 指定回复添加对话对象
  if (cardInfo.value.replyCid) {
    const { toUserBasicInfo } = cardInfo.value
    const atTag = `<a data-at href=${location.origin}/user/${toUserBasicInfo.uid}>@${toUserBasicInfo.nickname}  </a>`
    const dom = document.createElement('div')
    dom.innerHTML = cardInfo.value.content
    if (dom.getElementsByTagName('p')[0]) {
      dom.getElementsByTagName('p')[0].innerHTML = `${dom.getElementsByTagName('p')[0].innerHTML}`
    } else {
      if (dom.childNodes[0]?.childNodes[0]?.innerHTML) {
        dom.childNodes[0].childNodes[0].innerHTML = `${dom.childNodes[0].childNodes[0].innerHTML}`
      } else {
        dom.childNodes[0].innerHTML = `${dom.childNodes[0].innerHTML}`
      }
    }
    cardInfo.value.content = `${atTag}${dom.innerHTML}`
  }
}, {
  immediate: true,
  deep: true
})

watch(() => quoteVisible.value, (val) => {
  if (val) {
    setTimeout(() => {
      imgLazyLoad(quoteRef.value)
    },500)
  }
})

defineExpose({
  cardRef
})

</script>

<style lang="postcss" scoped>
.comment-card {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 24px 0;
  font-size: 16px;
  .avatar {
    flex: unset;
    flex-shrink: 0;
    margin-right: 12px;
  }
  &-main {
    flex: 1;
  }
  .avatar-info {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .avatar-info-lt,.avatar-info-rt {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
    }
    .avatar-info-lt {
      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-break: break-word;
      }
      .medal-icon {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
      }
    }
    .avatar-info-rt {
      flex-shrink: 0;
    }
    .svg-icon {
      flex-shrink: 0;
      margin-left: 24px;
    }
  }
  &-action {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
    justify-content: center;
    padding: 8px 0;
    overflow: hidden;
    dt {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 100%;
      font-size: 14px;
      padding: 11px 24px;
      cursor: pointer;
    }
    dt:hover {
      background-color: var(--background-light);
    }
    .hasline {
      border-bottom: 1px solid #F0F0F0;
    }
  }
  &-info {
    color: var(--text-hint);
    margin-top: 12px;
    span {
      margin-right: 24px;
      &:last-child {
        cursor: pointer;
      }
    }
    .secondary {
      color: var(--text-secondary);
      cursor: pointer;
    }
  }
  &-quote {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-end;
    justify-content: flex-start;
    width: 100%;
    padding: 16px;
    font-size: 16px;
    background-color: var(--background-light);
    margin: 8px 0;
    box-sizing: border-box;
    cursor: pointer;
    .quote {
      display: -webkit-box;
      line-height: 150%;
      -webkit-line-clamp: 3;
      text-overflow: ellipsis;
      word-break: break-word;
      -webkit-box-orient: vertical;
      overflow: hidden;
      width: 100%;
      :deep(p) {
        width: 100%;
        line-height: inherit;
        word-break: break-word;
      }
      :deep(img[data-type="live_self"]){
        display: none!important;
      }
      :deep(img[data-type="sticker_self"]) {
        width:auto;
        height:36px!important;
        display:inline;
        vertical-align: bottom;
        margin:0 2px !important;
        outline:none;
        background-color:transparent;
        pointer-events: none;
      }
    }
    .avatar {
      margin-top: 8px;
      span {
        margin-left: 8px;
        margin-right: 2px;
      }
    }
  }
  .content {
    word-break: break-word;
    line-height: 150%;
    margin-top: 6px;
    :deep(div) {
      display: inline;
    }
    :deep(p) {
      display: inline;
      line-height: inherit;
      &+p {
        display: block;
      }
    }
    :deep(a) {
      display: inline;
      color: var(--theme);
    }
    :deep(img) {
      display: block;
      margin-top: 12px;
      background-color: var(--color-background-tertiary);
    }
    :deep(div:has(img[data-type="live_self"])) {
      position: relative;
      display: block;
    }
    :deep(img[data-type="live_self"]){
      width:24px!important;
      height:24px!important;
      position: absolute;
      top: 16px!important;
      left: 16px!important;
      z-index: 99;
      background: transparent;
      margin:0;
    }
    :deep(img[data-type="sticker_self"]) {
      width:36px!important;
      height:auto;
      display:inline;
      vertical-align: bottom;
      margin:0 2px !important;
      outline:none;
      background-color:transparent;
      pointer-events: none;
    }
  }
  :deep(.el-drawer__body) {
    margin-bottom: 20px;
  }
  .quote-detail {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-end;
    width: 792px;
    margin: 48px auto;
    p {
      width: 100%;
      text-align: center;
      font-size: 28px;
      line-height: 100%;
      margin: 12px 0 60px;
    }
    div {
      width: 100%;
      overflow: auto;
      overflow-x: hidden;
      font-size: 18px;
      line-height: 150%;
      :deep(img) {
        width: 792px;
        padding: 16px 0;
      }
      &::-webkit-scrollbar {
        display: none;
      }
      :deep(img[data-type="sticker_self"]) {
        width:auto;
        height:36px!important;
        display:inline;
        vertical-align: bottom;
        margin:0 2px !important;
        padding: 0;
        outline:none;
        background-color:transparent;
        pointer-events: none;
      }
    }
    .avatar {
      margin-top: 40px;
      span {
        margin-left: 8px;
      }
    }
    :deep(div:has(img[data-value])) {
      position:relative;
      margin: 0 auto;
    }
    :deep(img[data-type="live_self"]) {
      width:36px!important;
      height:36px!important;
      position: absolute;
      top: 16px!important;
      left: 16px!important;
      z-index: 99;
      background: transparent;
      margin:0;
    }
  }
}
:deep(.el-dialog__header .title) {
  padding: 40px 0 32px 0;
  line-height: 32px;
  font-family: "orbit-R";
  font-size: 24px;
}

.user-container {
  padding: 0 40px 40px;
  width: 646px;
  box-sizing: border-box;
  .close {
    top: 40px;
    right: 24px;
    position: absolute;
    cursor: pointer;
    width: 24px;
    height: 24px;
    color: var(--text-primary);
  }
  .user-list {
    max-height: 388px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    a {
      font-size: 0;
    }
    li {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .name {
      font-size: 18px;
      line-height: 23px;
      margin-left: 12px;
      color: var(--text-primary);
    }
  }
}
.reply-card {
  padding: 0;
  font-size: 16px;
  margin-top: 24px;
}
@media (max-width: 1023px) {
  .comment-card, .reply-card {
    padding: 24px 20px;
  }
}


:deep(.merge-tag){
  color: rgba(179, 179, 179, 1);
  display: inline-block;
  font-size: 16px;
  margin-right: 24px;
  cursor: pointer;
}
</style>

<style lang="postcss">
.comment-card {
  --el-popper-border-radius: 8px;
  .el-popper__arrow {
    display: none;
  }
  .svg-icon {
    cursor: pointer;
  }
}

</style>